import _ from "lodash";
import { getThreadID, getPrimaryColorFunc } from "./utils";
import moment from "moment";

// Config Chart Metrics Activities Completion
const activitiesMetricConfigChart = {
  chart: {
    animation: "1",
    xaxisname: "Activities",
    yaxisname: "Number of Data Points",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoRegular",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoRegular",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoRegular",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontSize: "10px",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    divLineAlpha: "0",
    divLineDashed: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "42",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    reverseLegend: true,
    minimiseWrappingInLegend: true,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 3,

    //Scrollbar
    flatScrollBars: "1",
    scrollColor: "#fff",
    scrollheight: "7.5",
    scrollPadding: "5",

    numvisibleplot: 0
  },
  categories: [],
  dataset: []
};

const STATUS_STUDY_PROGRESS = {
  not_completed: "NotComplete",
  upcoming: "Upcoming",
  on_going: "Ongoing",
  completed: "Completed",
  not_scheduled: "Not Scheduled"
};

const PREFIX_CLASS = "classLabel";
const PREFIX_STATUS = "status";
const PREFIX_ACTIVITY_STATUS = "activityStatus";
const PREFIX_ACTIVITY_PROGRESS = "activityProgress";
const PREFIX_SCHEDULE_DAYS = "scheduledDays";
const PREFIX_ACTIVITY_NAME = "activityName";
const PREFIX_TOTAL_PERCENTAGE_COMPLETED = "totalPercentageCompleted";
const PREFIX_STATUS_TOOLTIP = "statusTooltip";

const STATUS_PROGRESS = {
  notCompleted: "NotComplete",
  completed: "Completed",
  upcoming: "Upcoming",
  onGoing: "Ongoing",
  notScheduled: "Not Scheduled"
};

function generateMappingStatusPerActivity(status) {
  const payload = {};
  switch (status) {
    case STATUS_STUDY_PROGRESS.not_completed:
      payload[PREFIX_CLASS] = "study-completion-box-incomplete";
      payload[PREFIX_STATUS_TOOLTIP] = "study-completion-tooltip-incomplete";
      payload[PREFIX_STATUS] = STATUS_STUDY_PROGRESS.not_completed;
      break;
    case STATUS_STUDY_PROGRESS.on_going:
      payload[PREFIX_CLASS] = "study-completion-box-ongoing";
      payload[PREFIX_STATUS_TOOLTIP] = "study-completion-tooltip-ongoing";
      payload[PREFIX_STATUS] = STATUS_STUDY_PROGRESS.on_going;
      break;
    case STATUS_STUDY_PROGRESS.not_scheduled:
      payload[PREFIX_CLASS] = "study-completion-box-notscheduled";
      payload[PREFIX_STATUS_TOOLTIP] = "study-completion-tooltip-notscheduled";
      payload[PREFIX_STATUS] = STATUS_STUDY_PROGRESS.not_scheduled;
      break;
    case STATUS_STUDY_PROGRESS.upcoming:
    case null:
    case undefined:
      payload[PREFIX_CLASS] = "study-completion-box-upcoming";
      payload[PREFIX_STATUS_TOOLTIP] = "study-completion-tooltip-upcoming";
      payload[PREFIX_STATUS] = STATUS_STUDY_PROGRESS.upcoming;
      break;
    default:
      payload[PREFIX_CLASS] = "study-completion-box-complete";
      payload[PREFIX_STATUS_TOOLTIP] = "study-completion-tooltip-complete";
      payload[PREFIX_STATUS] = STATUS_STUDY_PROGRESS.completed;
      break;
  }
  return payload;
}

function calculatePercentageCompletedStatus(value = 0, totalData = 0) {
  return !isNaN((Number(value) / Number(totalData)) * 100) ? (Number(value) / Number(totalData)) * 100 : 0;
}

function generateHeatmapData(rawData, chosenCountries = [], chosenSites = [], listParticipants = [], participantSelected = []) {
  let result = [];
  const isEmptyData = _.isEmpty(rawData);
  const isEmptyChosenCountries = _.isEmpty(chosenCountries);
  const isEmptyChosenSites = _.isEmpty(chosenSites);

  if (isEmptyData || isEmptyChosenCountries || isEmptyChosenSites) {
    return result;
  }

  for (const countryName in rawData) {
    if (chosenCountries !== "all" && chosenCountries[0] !== "all" && !chosenCountries.includes(countryName)) {
      continue;
    }
    const countryData = rawData[countryName];
    for (const siteName in countryData) {
      if (chosenSites[0] !== "all" && !chosenSites.includes(siteName)) {
        continue;
      }

      let siteData = [];
      siteData = countryData[siteName];

      if (Array.isArray(siteData) && siteData.length > 0) {
        siteData.map(site => {
          if (Array.isArray(participantSelected)) {
            if (participantSelected[0] !== "all" && participantSelected.indexOf(site.participantId) < 0) {
              return;
            }
          }
          // TODO: dont forget to change this to Thread ID
          const participantId = site.participantId;
          const participants = getThreadID(listParticipants, participantId);
          const activities = _.orderBy(site.activities, ["scheduledDays", d => _.toLower(d.activityName)], ["asc", "asc"]) || [];
          const matrixActivities = [];

          // Mapping activities into list activities per site data
          for (let indexActivities = 0; indexActivities < activities.length; indexActivities++) {
            if (activities[indexActivities]) {
              const activitiesPayload = generateMappingStatusPerActivity(activities[indexActivities][PREFIX_ACTIVITY_STATUS]);
              activitiesPayload[PREFIX_ACTIVITY_NAME] = activities[indexActivities][PREFIX_ACTIVITY_NAME];
              activitiesPayload[PREFIX_ACTIVITY_PROGRESS] = activities[indexActivities][PREFIX_ACTIVITY_PROGRESS];
              activitiesPayload[PREFIX_SCHEDULE_DAYS] = activities[indexActivities][PREFIX_SCHEDULE_DAYS] || 0;
              matrixActivities.push(activitiesPayload);
            }
          }

          const filterByCompletedStatus = matrixActivities.filter(ma => ma[PREFIX_STATUS] === STATUS_STUDY_PROGRESS.completed);

          const totalStatusWithoutNotScheduled = matrixActivities.filter(ma => ma[PREFIX_STATUS] !== STATUS_STUDY_PROGRESS.not_scheduled && ma[PREFIX_STATUS] !== STATUS_STUDY_PROGRESS.upcoming).length;

          const totalCompletedStatus = filterByCompletedStatus.length;

          const totalPercentageCompleted = totalStatusWithoutNotScheduled === 0 ? 0 : calculatePercentageCompletedStatus(totalCompletedStatus, totalStatusWithoutNotScheduled);

          const payload = {
            participants,
            matrixActivities,
            [PREFIX_TOTAL_PERCENTAGE_COMPLETED]: totalPercentageCompleted,
            country: countryName,
            site: siteName,
            percentage: {
              totalCompletedStatus,
              totalStatusWithoutNotScheduled
            }
          };

          result.push(payload);
        });
      }
    }
  }

  result = result.map(r => ({
    orderYAxis: r.participants && r.participants.participantId !== "" ? r.participants.participantId : r.participants ? r.participants.threadID : "",
    ...r
  }));
  result = _.orderBy(result, [d => d["orderYAxis"].toLowerCase()], ["asc"]);

  return result;
}

function calculateStudyWithActivitiesCompleted(matrix = []) {
  let completed = 0;
  if (!matrix) {
    return completed;
  }

  const dataSources = matrix.filter(m => m[PREFIX_TOTAL_PERCENTAGE_COMPLETED] === Number(100));

  return (completed = dataSources.length);
}

function calculateStudyWithActivities(matrix = []) {
  let result = {};
  let totalNotCompleted = 0;
  let totalOngoing = 0;
  let totalUpcoming = 0;
  if (!matrix) {
    return result;
  }

  matrix.map(row => {
    if (_.find(row.matrixActivities, { status: STATUS_PROGRESS.notCompleted })) {
      totalNotCompleted += 1;
    }
    if (_.find(row.matrixActivities, { status: STATUS_PROGRESS.onGoing })) {
      totalOngoing += 1;
    }
    if (_.find(row.matrixActivities, { status: STATUS_PROGRESS.upcoming })) {
      totalUpcoming += 1;
    }
  });

  result = {
    totalNotCompleted,
    totalOngoing,
    totalUpcoming
  };

  return result;
}

function countProgress(status) {
  const payload = { completed: 0, incompleted: 0 };

  if (status === STATUS_PROGRESS.notCompleted) {
    payload.incompleted = 1;
  } else if (status === STATUS_PROGRESS.completed) {
    payload.completed = 1;
  }

  return payload;
}

// Function to get chart data Activity Completion Metrics
function generateActivityCompletionMetrics(rawData, chosenCountries = [], chosenSites = [], participants = [], filterDate = []) {
  let result = null;

  let dataByActivities = [];
  let dataByCountries = [];
  let dataBySites = [];

  const isEmptyData = _.isEmpty(rawData);
  const isEmptyChosenCountries = _.isEmpty(chosenCountries);
  const isEmptyChosenSites = _.isEmpty(chosenSites);
  // const isEmptyListActivities = _.isEmpty(listActivities)

  if (isEmptyData || isEmptyChosenCountries || isEmptyChosenSites) {
    return result;
  }

  // Loop choosen country
  chosenCountries.forEach(countryName => {
    // check if country name in rawData object
    if (countryName in rawData) {
      const countryData = rawData[countryName];

      // Loop choosen sites
      chosenSites.forEach(siteName => {
        // Check if site name in country data
        if (siteName in countryData) {
          let siteData = [];
          if (Array.isArray(filterDate)) {
            if (filterDate[0] !== null && filterDate[1] !== null) {
              siteData = countryData[siteName].filter(s => moment(s.participantEnrollmentDate).isAfter(filterDate[0]) && moment(s.participantEnrollmentDate).isBefore(filterDate[1]));
            } else {
              siteData = countryData[siteName];
            }
          } else {
            siteData = countryData[siteName];
          }

          if (Array.isArray(siteData) && siteData.length > 0) {
            siteData.map(site => {
              if (Array.isArray(participants)) {
                if (participants[0] !== "all" && participants.indexOf(site.participantId) < 0) {
                  return;
                }
              }

              const activities = site.activities || [];
              if (Array.isArray(activities) && activities.length > 0) {
                activities.map(a => {
                  const indexActivity = _.findIndex(dataByActivities, dba => dba.label === a[PREFIX_ACTIVITY_NAME]);
                  const indexCountries = _.findIndex(dataByCountries, dba => dba.label === countryName);
                  const indexSites = _.findIndex(dataBySites, dba => dba.label === siteName);

                  if (indexActivity > -1) {
                    dataByActivities[indexActivity].completed += countProgress(a[PREFIX_ACTIVITY_STATUS]).completed;
                    dataByActivities[indexActivity].incompleted += countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted;
                  } else {
                    const payloadActivities = {
                      label: a[PREFIX_ACTIVITY_NAME],
                      completed: countProgress(a[PREFIX_ACTIVITY_STATUS]).completed,
                      incompleted: countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted
                    };

                    dataByActivities.push(payloadActivities);
                  }

                  if (indexCountries > -1) {
                    dataByCountries[indexCountries].completed += countProgress(a[PREFIX_ACTIVITY_STATUS]).completed;
                    dataByCountries[indexCountries].incompleted += countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted;
                  } else {
                    const payloadCountries = {
                      label: countryName,
                      completed: countProgress(a[PREFIX_ACTIVITY_STATUS]).completed,
                      incompleted: countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted
                    };

                    dataByCountries.push(payloadCountries);
                  }

                  if (indexSites > -1) {
                    dataBySites[indexSites].completed += countProgress(a[PREFIX_ACTIVITY_STATUS]).completed;
                    dataBySites[indexSites].incompleted += countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted;
                  } else {
                    const payloadSites = {
                      label: siteName,
                      completed: countProgress(a[PREFIX_ACTIVITY_STATUS]).completed,
                      incompleted: countProgress(a[PREFIX_ACTIVITY_STATUS]).incompleted
                    };

                    dataBySites.push(payloadSites);
                  }
                });
              }
            });
          }
        }
      });
    }
  });

  dataByActivities = dataByActivities.filter(item => {
    return item.completed !== 0 || item.incompleted !== 0;
  });
  dataByCountries = dataByCountries.filter(item => {
    return item.completed !== 0 || item.incompleted !== 0;
  });
  dataBySites = dataBySites.filter(item => {
    return item.completed !== 0 || item.incompleted !== 0;
  });

  dataByActivities = _.orderBy(dataByActivities, ["completed", d => d["label"].toLowerCase()], ["desc", "asc"]);
  dataByCountries = _.orderBy(dataByCountries, ["completed", d => d["label"].toLowerCase()], ["desc", "asc"]);
  dataBySites = _.orderBy(dataBySites, ["completed", d => d["label"].toLowerCase()], ["desc", "asc"]);

  result = { dataByActivities, dataByCountries, dataBySites };
  return result;
}

function generateSeriesActivitiesMetrics(matrix = []) {
  let result = null;

  const dataset = [];
  const categories = [];

  const category = matrix.map(({ label }) => ({ label }));
  const completedData = matrix.map(({ completed }) => ({ value: completed }));
  const incompleteData = matrix.map(({ incompleted }) => ({
    value: incompleted
  }));

  Array.from([STATUS_STUDY_PROGRESS.completed, "Not Completed"]).map(seriesname => dataset.push({ seriesname }));
  categories.push({ category });
  dataset[0] = {
    ...dataset[0],
    color: getPrimaryColorFunc(),
    data: completedData
  };

  dataset[1] = {
    ...dataset[1],
    color: "#fb9a99",
    data: incompleteData
  };

  if (category.length > 0 && completedData.length > 0 && incompleteData.length > 0) {
    result = { categories, dataset };
  }

  return result;
}

function filterParticipantListFromProgressResult(rawData, chosenCountries = [], chosenSites = [], listParticipants = []) {
  const listParticipantID = [];
  if (!rawData || !Array.isArray(chosenCountries) || chosenCountries.length < 1 || !Array.isArray(chosenSites) || chosenSites.length < 1) {
    return listParticipantID;
  }

  chosenCountries.forEach(countryName => {
    if (countryName in rawData) {
      const countryData = rawData[countryName];

      chosenSites.forEach(siteName => {
        if (siteName in countryData) {
          const siteData = countryData[siteName];

          if (Array.isArray(siteData) && siteData.length > 0) {
            siteData.map(n => listParticipants.indexOf(n.participantId) > -1 && listParticipantID.push(n.participantId));
          }
        }
      });
    }
  });

  return _.uniq(listParticipantID);
}

function generateDataRetentionRate(rawData) {
  const resTotal = [];
  const resDay = [];
  let resTotalAll = 0;
  const resData = [];
  let resAvarage = [];

  for (const month in rawData) {
    const resDataMonth = [100];
    const label = month || "";
    const total = rawData[month].Day_0.nParticipants || 0;

    resTotal.push({
      label: label,
      total: total
    });

    resTotalAll += total;

    for (const day in rawData[month]) {
      if (!resDay.includes(day.replace("_", " ")) && day !== "Day_0") {
        resDay.push(day.replace("_", " "));
      }

      if (day !== "Day_0") {
        const percentageParticipants = rawData[month][day].percentageParticipants.replace("%", "").replace(",", ".");
        resDataMonth.push(Number(percentageParticipants));
      }
    }

    resData.push(resDataMonth);
  }

  const tempAvarage = [];
  resData.map(row => {
    row.map((row2, index2) => {
      const i = _.findIndex(tempAvarage, { index: index2 });
      if (i >= 0) {
        tempAvarage[i].count += row2;
      } else {
        tempAvarage.push({
          index: index2,
          count: row2
        });
      }
    });
  });

  resAvarage = tempAvarage.map(row => {
    return row.count / resData.length;
  });

  return { resTotal, resDay, resTotalAll, resData, resAvarage };
}

function generateDataLineRetentionRate(rawData) {
  const resCategory = [
    {
      category: []
    }
  ];
  const resDataset = [
    {
      data: []
    }
  ];
  const tempCategory = [];
  const tempDataset = [];

  tempCategory.push({
    label: "Consented"
  });

  for (const month in rawData) {
    const resDataMonth = [100];

    for (const day in rawData[month]) {
      const i = _.findIndex(tempCategory, { label: day.replace("_", " ") });
      if (i < 0 && day !== "Day_0") {
        tempCategory.push({
          label: day.replace("_", " ")
        });
      }

      if (day !== "Day_0") {
        const percentageParticipants = rawData[month][day].percentageParticipants.replace("%", "").replace(",", ".");
        resDataMonth.push(Number(percentageParticipants));
      }
    }

    tempDataset.push(resDataMonth);
  }

  const tempAvarage = [];
  tempDataset.map(row => {
    row.map((row2, index2) => {
      const i = _.findIndex(tempAvarage, { index: index2 });
      if (i >= 0) {
        tempAvarage[i].count += row2;
      } else {
        tempAvarage.push({
          index: index2,
          count: row2
        });
      }
    });
  });

  resDataset[0].data = tempAvarage.map(row => {
    const val = row.count / tempDataset.length;
    return { value: 100 - val };
  });

  resCategory[0].category = tempCategory;

  return { resDataset, resCategory };
}
function getParticipantStudyProgress(rawData, chosenCountries = [], chosenSites = [], rawdata1, tab = null) {
  let studyDays;
  let milestones;
  for (let _i in rawdata1) {
    studyDays = rawdata1["studyDays"];
    milestones = rawdata1["milestones"];
  }
  const milestonesraw = [];
  let milecount = 0;
  const avg = (studyDays * 4) / 100;
  const arrayof = [];
  const milestart = [];
  for (const milestoness in milestones) {
    for (const anothermile in milestones[milestoness]) {
      milestart.push(milestones[milestoness][anothermile]);
    }
  }
  if (!(milestones == 0)) {
    for (const i in milestones) {
      let x, label;
      for (let j in milestones[i]) {
        milecount = milecount + 1;
        x = milestones[i][j];
        label = j;
      }
      if (x == milestart[0]) {
        arrayof.push(x);
        milestonesraw.push({
          label: "Study Start",
          x,
          showverticalline: "0"
        });
      } else {
        if (x - arrayof[arrayof.length - 1] > avg) {
          arrayof.push(x);
          milestonesraw.push({
            label,
            x,
            showverticalline: "1"
          });
        }
      }
    }
  } else {
    let x;
    const exp = studyDays / 10;
    for (let l = 0; l <= 10; l++) {
      x = exp * l;
      if (x == 0) {
        milestonesraw.push({
          label: "Study Start",
          x,
          showverticalline: "0"
        });
      } else if (x == studyDays) {
        milestonesraw.push({
          label: "Study Completion",
          x: studyDays,
          showverticalline: "1"
        });
      } else {
        milestonesraw.push({
          label: `${l * 10}"%"`,
          x,
          showverticalline: "1"
        });
      }
    }
  }
  if (!(milestones == 0)) {
    milestonesraw.push({
      label: "Study Completion",
      x: studyDays,
      showverticalline: "1"
    });
  }
  const response = {};
  response.data = [];
  response.data[0] = [];
  response.data[1] = [];
  response.data[3] = [{ category: milestonesraw }];
  response.csvData = [];
  response.color = [];
  const arr = [];
  let count = 0;
  if (!rawData || chosenCountries.length === 0 || chosenSites.length === 0) {
    return response;
  }
  const newRawData = rawData;
  let newestRawData;
  let averageStudyProgressions;
  for (let _i in newRawData) {
    newestRawData = newRawData["countries"];
    averageStudyProgressions = newRawData["averageStudyProgression"];
  }
  response.data[2] = [
    {
      line: [
        {
          startValue: averageStudyProgressions,
          isTrendZone: "0",
          color: "#A692F3",
          thickness: "2",
          dashed: "1",
          dashGap: "5",
          toolText: "Average Study Progression"
        }
      ]
    }
  ];
  if (tab == "Total") {
    Object.entries(newestRawData).forEach(([country, sites]) => {
      Object.entries(sites).forEach(([site, dataArray]) => {
        if ((chosenSites.includes("all") || chosenSites.includes(site)) && (chosenCountries.includes("all") || chosenCountries.includes(country))) {
          Object.values(dataArray).forEach(longData => {
            count = count + 3;
            response.data[0].push({
              y: count,
              z: "1",
              x: longData["daysInStudy"],
              name: longData["participantId"]
            });
          });
        }
      });
    });
  } else if (tab == "Countries") {
    Object.entries(newestRawData).forEach(([country, sites]) => {
      let lot = false;
      const countrys = country;
      const data = [];
      Object.entries(sites).forEach(([site, dataArray]) => {
        if ((chosenSites.includes("all") || chosenSites.includes(site)) && (chosenCountries.includes("all") || chosenCountries.includes(country))) {
          lot = true;
          Object.values(dataArray).forEach(longData => {
            count = count + 3;
            data.push({
              y: count,
              z: "1",
              x: longData["daysInStudy"],
              name: longData["participantId"]
            });
          });
        }
      });
      if (lot) {
        arr.push({
          seriesname: countrys,
          data
        });
        arr.sort((a, b) => a.seriesname.normalize().localeCompare(b.seriesname.normalize()));
        response.data[0] = arr;
      }
    });
  } else if (tab == "Sites") {
    Object.entries(newestRawData).forEach(([country, sites]) => {
      Object.entries(sites).forEach(([site, dataArray]) => {
        const countrys = site;
        const data = [];
        if ((chosenSites.includes("all") || chosenSites.includes(site)) && (chosenCountries.includes("all") || chosenCountries.includes(country))) {
          Object.values(dataArray).forEach(longData => {
            count = count + 3;
            data.push({
              y: count,
              z: "1",
              x: longData["daysInStudy"],
              name: longData["participantId"]
            });
          });
          arr.push({
            seriesname: countrys,
            data
          });
          arr.sort((a, b) => a.seriesname.normalize().localeCompare(b.seriesname.normalize()));
          response.data[0] = arr;
        }
      });
    });
  }
  Object.entries(newestRawData).forEach(([country, sites]) => {
    const countrys = country;
    Object.entries(sites).forEach(([site, dataArray]) => {
      if ((chosenSites.includes("all") || chosenSites.includes(site)) && (chosenCountries.includes("all") || chosenCountries.includes(country))) {
        Object.values(dataArray).forEach(longData => {
          response.csvData.push({
            countrys,
            site,
            y: count,
            z: "1",
            x: longData["daysInStudy"],
            name: longData["participantId"],
            averageStudyProgressions
          });
        });
      }
    });
  });
  return response;
}

function getsitesiteDiscontinuationActivity(rawData, chosenCountries = [], chosenSites = []) {
  const response = {};
  response.data = [];
  response.csvData = [];
  const arr = [];
  if (!rawData || chosenCountries.length === 0 || chosenSites.length === 0) {
    return response;
  }
  const newRawData = rawData;
  Object.entries(newRawData).forEach(([site, dataArray]) => {
    Object.entries(dataArray).forEach(([noindex, longdata]) => {
      if ((chosenSites.includes("all") || chosenSites.includes(noindex)) && (chosenCountries.includes("all") || chosenCountries.includes(site))) {
        Object.entries(longdata).forEach(([datapre, finalloop]) => {
          arr.push({
            label: datapre,
            value: finalloop
          });
        });
      }
    });
  });
  arr.sort((a, b) => a.label.normalize().localeCompare(b.label.normalize()));
  const collatedValues = arr.reduce((accumulator, currentValue) => {
    const existing = accumulator.find(n => n.label === currentValue.label);
    if (existing) {
      existing.value += currentValue.value;
    } else {
      accumulator.push(currentValue);
    }
    return accumulator;
  }, []);
  for (const key in collatedValues) {
    response.csvData.push(collatedValues[key]);
  }
  response.csvData.sort(function(a, b) {
    return b.value - a.value;
  });
  if (response.csvData.length <= 6) {
    response.data = "14px";
  } else if (response.csvData.length <= 12) {
    response.data = "12px";
  } else {
    response.data = "9px";
  }
  return response;
}
function getsiteOtherDiscontinuationReasons(rawData, chosenCountries = [], chosenSites = []) {
  const response = {};
  response.data = [];
  response.csvData = [];
  const arr = [];
  Object.entries(rawData).forEach(([country, sites]) => {
    Object.entries(sites).forEach(([site, dataArray]) => {
      if ((chosenSites.includes("all") || chosenSites.includes(site)) && (chosenCountries.includes("all") || chosenCountries.includes(country))) {
        Object.entries(dataArray).forEach(([datapre, finalloop]) => {
          let answer = datapre.toLowerCase();
          answer = answer.trim();
          arr.push({
            answer,
            total: finalloop
          });
        });
      }
    });
  });
  arr.sort((a, b) => a.answer.normalize().localeCompare(b.answer.normalize()));
  const collatedValues = arr.reduce((accumulator, currentValue) => {
    const existing = accumulator.find(n => n.answer === currentValue.answer);
    if (existing) {
      existing.total += currentValue.total;
    } else {
      accumulator.push(currentValue);
    }
    return accumulator;
  }, []);
  for (const key in collatedValues) {
    response.csvData.push(collatedValues[key]);
  }
  response.csvData.sort(function(a, b) {
    return b.total - a.total;
  });
  response.csvData = response.csvData.slice(0, 10);
  return response;
}
export { activitiesMetricConfigChart, generateHeatmapData, calculateStudyWithActivitiesCompleted, generateActivityCompletionMetrics, generateSeriesActivitiesMetrics, calculateStudyWithActivities, filterParticipantListFromProgressResult, generateDataRetentionRate, generateDataLineRetentionRate, getParticipantStudyProgress, getsitesiteDiscontinuationActivity, getsiteOtherDiscontinuationReasons };
